export default __webpack_public_path__ + "static/media/exclamation-red.586d03ab.svg";